"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("react");

var _propTypes = require("prop-types");

var Buttons = _interopRequireWildcard(require("../../../components/input/button/Button"));

var Widgets = _interopRequireWildcard(require("../../../components/input/widget/Widget"));

var css = _interopRequireWildcard(require("./AdyenIframe.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AdyenIframe = /*#__PURE__*/function (_Component) {
  _inherits(AdyenIframe, _Component);

  var _super = _createSuper(AdyenIframe);

  function AdyenIframe(props) {
    var _this;

    _classCallCheck(this, AdyenIframe);

    _this = _super.call(this, props);
    _this.iframeRef = /*#__PURE__*/(0, _react.createRef)();
    _this.onMessageReceived = _this.onMessageReceived.bind(_assertThisInitialized(_this));
    _this.onSaveNow = _this.onSaveNow.bind(_assertThisInitialized(_this));
    _this.getParameters = _this.getParameters.bind(_assertThisInitialized(_this));
    _this.state = {
      paymentMethodType: 'card'
    };
    return _this;
  }

  _createClass(AdyenIframe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('message', this.onMessageReceived, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onMessageReceived, false);
    }
  }, {
    key: "onMessageReceived",
    value: function onMessageReceived(e) {
      var _this$props = this.props,
          onDone = _this$props.onDone,
          onAgreementClick = _this$props.onAgreementClick;

      switch (e.data.event) {
        case 'paymentMethodCapture:done':
          {
            onDone(e.data.data.data);
            break;
          }

        case 'paymentMethodCapture:showAgreementTerms':
          {
            onAgreementClick();
            break;
          }

        case 'paymentMethodCapture:changePaymentMethodType':
          {
            console.log('paymentMethodCapture:changePaymentMethodType', e.data.data);
            this.setState({
              paymentMethodType: e.data.data
            });
            break;
          }

        default:
          break;
      }
    }
  }, {
    key: "onSaveNow",
    value: function onSaveNow(hostedPageUrl) {
      this.iframeRef.current.contentWindow.postMessage('paymentMethodCapture:save', hostedPageUrl);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getParameters",
    value: function getParameters(props) {
      var actionName = 'a=save';
      var bankAccountEnabled = "b=true";
      var country = "c=NZ";
      var cardGateway = 'd=Adyen';
      var serverTime = "t=".concat(props.serverTime);
      var hideTermsAndConditions = 'tc=true';
      var adyenData = "ad=".concat(JSON.stringify(props.adyenData));
      var params = [actionName, bankAccountEnabled, country, cardGateway, serverTime, hideTermsAndConditions, adyenData];
      return "".concat(props.hostedPageUrl, "?").concat(params.join('&'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          hostedPageUrl = _this$props2.hostedPageUrl,
          onLoad = _this$props2.onLoad,
          isPrimary = _this$props2.isPrimary,
          onPrimaryClicked = _this$props2.onPrimaryClicked,
          onAgreementClick = _this$props2.onAgreementClick;
      var paymentMethodType = this.state.paymentMethodType;
      return (0, _jsxRuntime.jsxs)("div", {
        css: css.adyenIframe,
        children: [(0, _jsxRuntime.jsx)("h1", {
          css: css.heading,
          children: "Link a debit card"
        }), (0, _jsxRuntime.jsx)("p", {
          children: "Store securely for future repayments."
        }), (0, _jsxRuntime.jsx)("iframe", {
          css: css.iframe(paymentMethodType),
          ref: this.iframeRef,
          title: "Add a payment method",
          id: "hosted-payment-page",
          src: this.getParameters(this.props),
          scrolling: "no",
          frameBorder: "0",
          sandbox: "allow-same-origin allow-scripts allow-forms",
          onLoad: onLoad
        }), (0, _jsxRuntime.jsx)(Widgets.Checkbox, {
          css: css.checkbox,
          checked: isPrimary,
          onChange: onPrimaryClicked,
          name: "checkedB",
          color: "primary",
          label: "Set as default"
        }), (0, _jsxRuntime.jsxs)("small", {
          children: ["I authorise the direct debit and agree to the terms of the", ' ', (0, _jsxRuntime.jsx)(Buttons.Text, {
            css: css.link,
            onClick: onAgreementClick,
            children: "Direct Debit Request and Service Agreement"
          }), "."]
        }), (0, _jsxRuntime.jsx)("h5", {
          children: "Verifying your card"
        }), (0, _jsxRuntime.jsx)("small", {
          css: css.bottomText,
          children: "$1 will appear as pending on your card\u2019s transaction history, but don\u2019t worry, it\u2019ll disappear in a few days."
        }), (0, _jsxRuntime.jsx)("div", {
          css: css.saveButton,
          children: (0, _jsxRuntime.jsx)(Buttons.Primary, {
            fullWidth: true,
            onClick: function onClick() {
              return _this2.onSaveNow(hostedPageUrl);
            },
            children: "Save"
          })
        })]
      });
    }
  }]);

  return AdyenIframe;
}(_react.Component);

AdyenIframe.propTypes = {
  /**
   * Url of the hosted page.
   */
  hostedPageUrl: _propTypes.string.isRequired,

  /**
   * Time of the server in the format 2021-07-19T21:27:43.0180154 10:00
   */
  serverTime: _propTypes.string.isRequired,

  /**
   * Iframe parameters in this format
   * {
   *     "adyenData": {
   *       "currencyCode": "NZD",
   *       "merchantAccount": "ZipMoney-Sandbox-NZ",
   *       "merchantReference": "524fe24d-3953-4db4-9942-ec689909326a",
   *       "paymentAmount": "100",
   *       "sessionValidity": "2021-07-19T21:07:18Z",
   *       "skinCode": "wEelkqYu",
   *       "shipBeforeDate": "2021-07-20",
   *       "shopperReference": "303590",
   *       "recurringContract": "RECURRING",
   *       "shopperEmail": "zipcredit_1610551227716@mailinator.com"
   *     },
   *     "merchantSig": "zuS04sV anYVwY SCg9uQ0lv k27Bhm31MenqHEzuCk="
   *   }
   */
  adyenData: _propTypes.object.isRequired,

  /**
   * Value of the primary check box indicating primary payment method
   */
  isPrimary: _propTypes.bool.isRequired,

  /**
   * Function to be called when iframe is loaded
   */
  onLoad: _propTypes.func,

  /**
   * Function to be called when iframe post is completed
   */
  onDone: _propTypes.func,

  /**
   * Function to be called when primary payment method checkbox is clicked
   */
  onPrimaryClicked: _propTypes.func,

  /**
   * Function to be called when `Direct Debit Service Agreement` link is clicked
   */
  onAgreementClick: _propTypes.func
};
AdyenIframe.defaultProps = {
  onLoad: null,
  onDone: null,
  onPrimaryClicked: null,
  onAgreementClick: null
};
var _default = AdyenIframe;
exports["default"] = _default;